import React from 'react';
import cx from 'classnames';
import { SLDSInlineEdit } from '@salesforce/design-system-react';

/**
 * This component has been deprecated in DSR, thus we removed the Storybook
 * story for it.
 */
function InlineEdit({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSInlineEdit, Object.assign({}, props, {
    className: cx(className, "tds-form-element_inline-edit")
  }));
}
InlineEdit.displayName = "InlineEdit";

export { InlineEdit as default };
